import React, { Component } from 'react'
import { getAttributeCourseStaticInfo } from '../../helpers/enrolment'
import { getProperty } from '../../helpers/properties'
import Loading from '../tags/Loading'
import { getSoneFundingByCourseSSPNo, getSonePersonalDetails } from '../../services/vu'
import FinanceContainer from '../tags/FinanceContainer'
import { isBefore } from 'date-fns'
import { isElgibleForFundingType, isHelpSubmitted } from '../../helpers/funding'

export default class ManageFinance extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      courseId: '',
      courseTitle: '',
      myvuLink: getProperty('myVuSiteUrl'),
      fundingInfo: null,
      personalDetails: null,
      isAbleToEdit: true,
      submitting: false,
      isStudyPlanExpanded: false,
      fundingApiFailed: false
    }
  }

  stopLoading = (newState = {}) => {
    this.setState({
      loading: false,
      ...newState
    })
  }

  componentDidMount() {
    getSonePersonalDetails().then(personalDetails => {
      Promise.all([getSoneFundingByCourseSSPNo(getAttributeCourseStaticInfo('courseSSPNo'), getAttributeCourseStaticInfo('liabilityCategoryCode'), personalDetails.stuCitizenCd)])
        .then(([fundingInfo]) => {
          this.stopLoading({
            fundingInfo: fundingInfo,
            personalDetails: personalDetails,
            courseTitle: getAttributeCourseStaticInfo('courseTitle'),
            courseCode: getAttributeCourseStaticInfo('courseCode'),
            isStudyPlanExpanded: getAttributeCourseStaticInfo('isStudyPlanExpanded') === 'Y',
            isAbleToEdit:
              (isElgibleForFundingType('FEE-FREE', fundingInfo, personalDetails) && !isHelpSubmitted('FEE-HELP', fundingInfo)) ||
              (isElgibleForFundingType('FEE-HELP', fundingInfo, personalDetails) && !isHelpSubmitted('FEE-HELP', fundingInfo)) ||
              (isElgibleForFundingType('SA-HELP', fundingInfo, personalDetails) && !isHelpSubmitted('SA-HELP', fundingInfo)) ||
              (isElgibleForFundingType('HECS-HELP', fundingInfo, personalDetails) && !isHelpSubmitted('HECS-HELP', fundingInfo))
          })
        })
        .catch(() => {
          this.stopLoading({
            courseTitle: getAttributeCourseStaticInfo('courseTitle'),
            courseCode: getAttributeCourseStaticInfo('courseCode'),
            fundingApiFailed: true,
            isStudyPlanExpanded: getAttributeCourseStaticInfo('isStudyPlanExpanded') === 'Y'
          })
        })
    })
  }

  componentDidUpdate(prevProps, prevState) {}

  reloadFunding = () => {
    this.setState({
      loading: true
    })

    getSoneFundingByCourseSSPNo(getAttributeCourseStaticInfo('courseSSPNo'), getAttributeCourseStaticInfo('liabilityCategoryCode'), this.state.personalDetails.stuCitizenCd)
      .then(fundingInfo => {
        this.stopLoading({
          fundingInfo: fundingInfo,
          isAbleToEdit: false
        })
      })
      .catch(error => {
        this.stopLoading({
          fundingApiFailed: true,
          isAbleToEdit: false
        })
      })
  }

  getNavigateText = () => {
    return 'Return to MyVU'
  }

  progressForm = () => {
    let baseUrl = this.state.myvuLink
    if (!baseUrl.endsWith('/')) {
      baseUrl += '/'
    }

    window.location = baseUrl + 'financial-support?success=true'
  }

  render() {
    if (this.state.loading) {
      return <Loading />
    }

    return (
      <div className="manage-enrol">
            <div className="enrol-header">
              <div className="left">
                <div className="page-name">ENROL MODE</div>
              </div>
              <div className="right">
                <button className="btn btn-primary btn-submit" onClick={this.progressForm}>
                  {this.getNavigateText()}
                </button>
              </div>
            </div>
        
        <div className="financialContainer">
          <div className="enrol-container">

            <div className="finance-title">
              <h1>My Finance</h1>
              {!!this.state.courseTitle && (
                <h2>
                  {this.state.courseTitle} {this.state.courseCode ? `[${this.state.courseCode}]` : ''}
                </h2>
              )}
            </div>

            <FinanceContainer
              isStudyPlanExpanded={this.state.isStudyPlanExpanded}
              successFinish={this.reloadFunding}
              fundingInfo={this.state.fundingInfo}
              personalDetails={this.state.personalDetails}
              fundingApiFailed={this.state.fundingApiFailed}
              isAbleToEdit={this.state.isAbleToEdit}
            />
          </div>
         
        </div>
      </div>
    )
  }
}
